import React from 'react';
import { graphql, PageProps, HeadProps } from 'gatsby';
import { SEO } from '../components/Seo';
import { ArticleListing } from '../components/templates/articleListing/ArticleListing';
import { Breadcrumb } from '../components/breadcrumb/Breadcrumb';
import { useGlobalSettings } from '../hooks/useGlobalSettings';

const BlogListing = ({
  data: { page, articles },
  pageContext,
}: PageProps<Queries.UmbracoBlogListingQueryQuery>) => {
  const name = page?.name;

  return (
    <>
      <Breadcrumb page={page} />
      <ArticleListing
        heading={name ?? ''}
        items={articles.nodes}
        pageContext={pageContext}
      />
    </>
  );
};

export default BlogListing;

export const Head = ({
  data,
}: HeadProps<Queries.UmbracoBlogListingQueryQuery>) => {
  const {
    siteMeta: { siteUrl },
  } = useGlobalSettings();
  const seo = data.page?.properties?.seo;
  return <SEO data={seo} canonical={`${siteUrl}${data?.page?.url}`} />;
};

export const umbracoBlogListingQuery = graphql`
  query UmbracoBlogListingQuery($ids: [String], $pageId: String) {
    page: umbracoBlogListingType(id: { eq: $pageId }) {
      name
      url
      remoteId
      parentPages {
        url
        name
      }
      ... on UMBRACO_BlogListingType {
        properties {
          seo {
            ...SEO
          }
        }
      }
    }
    articles: allUmbracoBlogArticleType(
      filter: { id: { in: $ids } }
      sort: { publishDate: DESC }
    ) {
      nodes {
        ...BlogArticleCard
      }
    }
  }
`;
